<template>
  <div class="all-artists__dropdown">
    <dropdown-sub
      v-model="sort"
      :options="values"
      :placeholder="placeholder"/>
  </div>
</template>


<script>
  import dropdownSub from "../../lib/dropdownSub";
  import SortTypeMix from "../../../../../components/list/filter/SortTypeMix";

  export default {
    components: { dropdownSub },
    name      : 'sort-type-sub',
    mixins: [SortTypeMix],

    methods: {
      get_value() {
        let val_str='';
        if (typeof this.value === 'object') val_str=this.value.value;

        return val_str;
      },

      set_val(new_val){
        //console.log(new_val);
        //this.$emit('input', new_val);
        //this.onChange ? this.onChange(new_val) : null;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/list/filter/SortTypeSub.vue